
const handleSidebar = (show=true) => {
    if (show) {
        document.body.classList.add('g-sidenav-pinned');
    } else {
        document.body.classList.remove('g-sidenav-pinned');
    }
};

export default handleSidebar;